import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { CButton } from '@coreui/react-pro';
import dayjs from 'dayjs';

import { getTimeZoneGuess, numberWithCommas, tryParseJSON } from '../../../../../../utils';
import {
     CART_TYPES,
     LOCAL_CART,
     LOCAL_TIME_ZONE,
     PRODUCT_TYPES_REQUIRE_EVENT,
     STATUS,
     SUBSCRIBER_PATH,
     TAB_SELECT_PURCHASE,
     TRAINING_PRODUCT_TYPES,
} from '../../../../../../constants';
import IconMan from '../../../../../../assets/images/icon-man.svg';

import TooltipWithIcon from '../../../../../General/Tooltips/TooltipWithIcon';
import SelectTrainingDate from './SelectTrainingDate';
import SelectTrainingTier from './SelectTrainingTier';
import { TrainingProductCardContext } from './TrainingProductCard';

import { fetchGuestContentManagements } from '../../../../../../containers/guest/action';

const TeamTrainingTab = () => {
     const {
          listProductCart,
          listProducts,
          product,
          setProductId,
          listProductTypeRequireEvent,
          addToCart,
          setListProductCart,
          setProduct,
          setListProducts,
          disableCartButton,
     } = useContext(TrainingProductCardContext);

     const dispatch = useDispatch();
     const navigate = useNavigate();

     const contentManagements = useSelector((state) => state.subscriber.contentManagements);
     const timezoneSelected = localStorage.getItem(LOCAL_TIME_ZONE) || getTimeZoneGuess();
     const today = dayjs().tz(timezoneSelected);

     //get data cart
     const cartItems = useSelector((state) => state.subscriber.cart.items);
     const cartLocalStorage = tryParseJSON(localStorage.getItem(LOCAL_CART));
     const cartType = cartLocalStorage?.type;

     const navigateSellingGroup = () => {
          if (!listProducts.length) {
               navigate(SUBSCRIBER_PATH.SELLING_GROUPS);
          }
     };

     const fetchDataContentManagements = () => {
          if (!contentManagements.length) {
               dispatch(fetchGuestContentManagements());
          }
     };

     useEffect(() => {
          navigateSellingGroup();
          fetchDataContentManagements();
     }, []); // eslint-disable-line react-hooks/exhaustive-deps

     const titleTabTeam = contentManagements.find((content) => content.key === 'pageSellingGroupDetailTitleTabTeam');
     const contentTooltipTabTeam = contentManagements.find((content) => content.key === 'pageSellingGroupDetailContentTooltipTabTeam');
     const contentTooltipCE = contentManagements.find((content) => content.key === 'pageSellingGroupDetailContentTooltipCE');
     const contentFooter = contentManagements.find((content) => content.key === 'pageSellingGroupDetailContentFooter');

     const reduceSeat = (productSeat) => {
          if (productSeat.quantityCart > productSeat.organizationMin) {
               const newProduct = {
                    ...productSeat,
                    quantityCart: productSeat.quantityCart - 1,
               };
               const productCartIndex = listProductCart.findIndex((item) => item.id === newProduct.id);

               const newListProductCart = [...listProductCart];
               newListProductCart[productCartIndex] = newProduct;

               setListProductCart(newListProductCart);
               if (productSeat.id === product.id) {
                    setProduct(newProduct);
               }

               const productIndex = listProducts.findIndex((item) => item.id === newProduct.id);
               const newProducts = [...listProducts];
               newProducts[productIndex] = newProduct;
               setListProducts(newProducts);
          } else {
               setProductId(productSeat);
          }
     };

     const increaseSeat = (productSeat) => {
          const quantityCartItem = cartItems?.find((item) => item.productId === product.id)?.quantity;

          const newQuantity = productSeat.quantityCart + 1;
          const comparisonQuantity = quantityCartItem + newQuantity > productSeat.organizationMax;
          const conditionPurchaseSeat = productSeat.organizationMax === -1 ? false : comparisonQuantity;
          const cartTypeIndividual = cartType && cartType === CART_TYPES.INDIVIDUAL;

          if ((quantityCartItem && conditionPurchaseSeat && !cartTypeIndividual) || conditionPurchaseSeat) {
               toast.error('Maximum seat purchase has been exceeded is ' + productSeat.organizationMax);
               return;
          } else {
               if (productSeat.quantityCart < productSeat.organizationMax || productSeat.value === 'custom' || productSeat.organizationMax === -1) {
                    const newProduct = {
                         ...productSeat,
                         quantityCart: newQuantity,
                    };
                    const productCartIndex = listProductCart.findIndex((item) => item.id === newProduct.id);

                    const newListProductCart = [...listProductCart];
                    newListProductCart[productCartIndex] = newProduct;
                    setListProductCart(newListProductCart);
                    if (productSeat.id === product.id) {
                         setProduct(newProduct);
                    }

                    const productIndex = listProducts.findIndex((item) => item.id === newProduct.id);
                    const newProducts = [...listProducts];
                    newProducts[productIndex] = newProduct;
                    setListProducts(newProducts);
               }

               if (productSeat.quantityCart === productSeat.organizationMax && productSeat.organizationMax !== -1) {
                    toast.error('Maximum seat purchase is ' + productSeat.organizationMax);
                    return;
               }
          }
     };
     const priceMultipleTotal = listProductCart.reduce((pricingTotal, productCartItem) => {
          const isLiveTraining = productCartItem.productType.trainingProductType === TRAINING_PRODUCT_TYPES.LIVE_TRAINING;

          const quantityEventProduct = productCartItem.listEventSelected?.reduce((i, j) => {
               const newQuantityEvent = j.value ? j.quantityEvent : 0;
               return i + (newQuantityEvent || 0);
          }, 0);

          let totalPriceEvent = 0;
          if (productCartItem.listEventSelected?.length > 0 && !productCartItem.selectedEventCreditQuantity) {
               totalPriceEvent = productCartItem.price * quantityEventProduct;
          }
          if (productCartItem.selectedEventCreditQuantity) {
               totalPriceEvent = productCartItem.price * productCartItem.selectedEventCreditQuantity;
          }

          let totalPriceTier = 0;
          if (productCartItem.listTierSelected?.length > 0) {
               totalPriceTier = productCartItem.listTierSelected.reduce((prev, current) => {
                    const tierPrice = parseFloat(current.price);
                    const tierQuantity = parseInt(current.quantity);
                    current = tierPrice * tierQuantity;
                    return prev + current;
               }, 0);
          }

          const totalPriceProduct = isLiveTraining ? totalPriceEvent + totalPriceTier : productCartItem.price * productCartItem.quantityCart;

          return pricingTotal + totalPriceProduct;
     }, 0);

     const eventHasTrainingCart = listProductCart.some((cart) => {
          const checkLiveTraining = cart.productType.trainingProductType === TRAINING_PRODUCT_TYPES.LIVE_TRAINING;
          if (checkLiveTraining && cart.listEventSelected?.length <= 0) {
               return true;
          }
          return false;
     });

     const listEventNoSelectInCart = listProductCart.filter((itemCart) => {
          const isLiveTraining = itemCart.productType?.trainingProductType === TRAINING_PRODUCT_TYPES.LIVE_TRAINING;

          if (!isLiveTraining) return false;

          if (itemCart.selectedEventCredit) return itemCart.selectedEventCreditQuantity < 1;

          const isNotSelectEvent = itemCart.listEventSelected?.length <= 0;
          const isNotSelectTier = !itemCart.listTierSelected || itemCart.listTierSelected.length <= 0;

          return isNotSelectEvent && isNotSelectTier;
     });

     const checkOnlyEventNotSelectInCart = listEventNoSelectInCart?.length === listProductCart?.length;

     const checkEventCreditSelected = listProductCart.find((item) => {
          const isSelectCreditQuantity = item.allowPurchaseEventCredit && item.selectedEventCredit && item?.selectedEventCreditQuantity > 0;

          if (item.listEventSelected?.length || !isSelectCreditQuantity) return true;

          return isSelectCreditQuantity;
     });

     const checkValidCartItems = !checkOnlyEventNotSelectInCart && checkEventCreditSelected;

     const isInvisiblePurchase = product?.purchaseType === CART_TYPES.INVISIBLE;
     const showSectionTotal = listProductCart.length > 0 && (checkValidCartItems || isInvisiblePurchase);
     const showAddToCart = !isInvisiblePurchase && (!eventHasTrainingCart || checkEventCreditSelected);

     const onSelectTeam = (pro) => {
          const quantityCartItem = +cartItems?.find((item) => item.productId === pro.id)?.quantity || 0;
          if (pro.events.length > 0) {
               setProductId(pro);
               return;
          }

          const quantityExceedsMax = pro.organizationMax === -1 ? false : quantityCartItem + pro.organizationMin > pro.organizationMax;

          const conditionSelectTeam = pro.organizationMax === -1 ? false : quantityCartItem >= pro.organizationMax;
          const cartTypeIndividual = cartType && cartType === CART_TYPES.INDIVIDUAL;

          if ((quantityCartItem && conditionSelectTeam && !cartTypeIndividual) || quantityExceedsMax) {
               toast.error('Maximum seat purchase has been exceeded is ' + pro.organizationMax);
               return;
          } else {
               setProductId(pro);
          }
     };

     return (
          <div id="group-products" className="product-type">
               <div className="d-flex title-product-card">
                    <p>
                         {titleTabTeam?.value}
                         <TooltipWithIcon className="tooltip-info" content={contentTooltipTabTeam?.value} trigger="mouseenter focus" />
                    </p>
               </div>
               {listProducts.map((pro, index) => {
                    const trainingProductType = pro.productType.trainingProductType;
                    const isLiveTraining = pro.productType?.trainingProductType === TRAINING_PRODUCT_TYPES.LIVE_TRAINING;
                    const checkTypeTrainingEvent = PRODUCT_TYPES_REQUIRE_EVENT.includes(trainingProductType);
                    const isCustomDateEnabled = pro.customEventEnable;
                    const isPurchaseCreditEnabled = pro.allowPurchaseEventCredit;
                    const isNotHaveEvents = !pro.events?.length;

                    const isHaveInvalidEvent = !pro.events.some(
                         (event) =>
                              !event.isPrivate &&
                              event.status === STATUS.ENABLE &&
                              dayjs(event.startAt).tz(timezoneSelected) >= today &&
                              (event.remainingSeats > 0 || event.remainingSeats === null)
                    );

                    const checkInvalidEvents = isLiveTraining && (isNotHaveEvents || isHaveInvalidEvent);

                    const isSelectDisabled = !isCustomDateEnabled && checkInvalidEvents && !isPurchaseCreditEnabled;

                    const messageNoEvents = isCustomDateEnabled
                         ? 'There are no planned events. You can still purchase a custom event date.'
                         : 'There are no planned events, please come back later.';

                    const quantityCartItem = +cartItems?.find((item) => item.productId === pro.id)?.quantity || 0;
                    const newQuantity = pro.quantityCart + 1;
                    const comparisonQuantity = quantityCartItem + newQuantity > pro.organizationMax;
                    const conditionPurchaseSeat = pro.organizationMax === -1 ? false : comparisonQuantity;

                    return (
                         <div className="product-detail pane-training" key={index}>
                              <div className="card card-product">
                                   <div className="card-body">
                                        <h4>
                                             {pro.genericPublicName}
                                             {(pro?.productType?.trainingProductType === TRAINING_PRODUCT_TYPES.CE_CREDITS ||
                                                  pro?.productType?.trainingProductType === TRAINING_PRODUCT_TYPES.TEST_ONLY) && (
                                                  <TooltipWithIcon
                                                       className="tooltip-info"
                                                       content={contentTooltipCE?.value}
                                                       trigger="mouseenter focus"
                                                  />
                                             )}
                                        </h4>
                                        <div className="card-text">
                                             {pro.shortDescription && (
                                                  <div className="course-description" dangerouslySetInnerHTML={{ __html: pro.shortDescription }} />
                                             )}
                                        </div>
                                        {trainingProductType === TRAINING_PRODUCT_TYPES.LIVE_TRAINING && (
                                             <p className="mb-3">
                                                  <strong>Purchase individual training seats for your team</strong>
                                             </p>
                                        )}
                                        <div className="select-training-product price-training-product">
                                             {pro.preventPurchase ? (
                                                  <span className="sub-seat text-secondary">
                                                       {pro.preventPurchaseText || 'This product is not available now'}
                                                  </span>
                                             ) : pro?.purchaseType !== CART_TYPES.INVISIBLE ? (
                                                  <>
                                                       {pro.selected ? (
                                                            <>
                                                                 {checkTypeTrainingEvent ? (
                                                                      <div className="select-training-date">
                                                                           <CButton
                                                                                className="btn-select-course btn-outline-primary"
                                                                                type="button"
                                                                                onClick={() => {
                                                                                     setProductId(pro);
                                                                                }}
                                                                           >
                                                                                SELECT
                                                                           </CButton>
                                                                      </div>
                                                                 ) : (
                                                                      <div className="change-quantity">
                                                                           <span
                                                                                className="btn btn-select-quantity"
                                                                                onClick={() =>
                                                                                     reduceSeat(listProductCart.find((item) => item.id === pro.id))
                                                                                }
                                                                           >
                                                                                -
                                                                           </span>
                                                                           <span className="quantity">
                                                                                <img src={IconMan} width={20} height={20} alt="Icon man" />

                                                                                <span className="quantity">
                                                                                     {
                                                                                          listProductCart.find((item) => item.id === pro.id)
                                                                                               ?.quantityCart
                                                                                     }
                                                                                </span>
                                                                           </span>
                                                                           <span
                                                                                className="btn btn-select-quantity"
                                                                                onClick={() => {
                                                                                     if (conditionPurchaseSeat) {
                                                                                          toast.error(
                                                                                               'Maximum seat purchase has been exceeded is ' +
                                                                                                    pro.organizationMax
                                                                                          );
                                                                                          return;
                                                                                     }
                                                                                     increaseSeat(listProductCart.find((item) => item.id === pro.id));
                                                                                }}
                                                                           >
                                                                                +
                                                                           </span>
                                                                      </div>
                                                                 )}
                                                            </>
                                                       ) : (
                                                            <CButton
                                                                 className="btn-border btn btn-select-course btn-outline-primary"
                                                                 disabled={isSelectDisabled}
                                                                 onClick={() => {
                                                                      if (!isSelectDisabled) onSelectTeam(pro);
                                                                 }}
                                                            >
                                                                 SELECT
                                                            </CButton>
                                                       )}
                                                  </>
                                             ) : (
                                                  <CButton onClick={() => setProductId(pro)}>Select</CButton>
                                             )}
                                             <span className="price">PRICE</span>
                                             <strong>{`$${pro.price}`}</strong>
                                        </div>

                                        {pro.selected && !isSelectDisabled && (
                                             <SelectTrainingDate
                                                  productSelected={pro}
                                                  typeOfPurchase={TAB_SELECT_PURCHASE.TEAM_TRAINING}
                                                  listProductTypeRequireEvent={listProductTypeRequireEvent}
                                             />
                                        )}

                                        {pro.tieredPricingEnable && pro.pricingTiers && <SelectTrainingTier productSelected={pro} />}

                                        {checkInvalidEvents && !isPurchaseCreditEnabled && !pro.preventPurchase && (
                                             <p className="mt-2 d-block" style={{ fontSize: '15px' }}>
                                                  {messageNoEvents}
                                             </p>
                                        )}
                                   </div>
                              </div>
                         </div>
                    );
               })}

               {showSectionTotal && (
                    <div className="d-flex sum-total">
                         <div className="total-selection">
                              <h5>TOTAL FOR SELECTION</h5>
                              <strong>${numberWithCommas(priceMultipleTotal?.toFixed(2))}</strong>
                              {product?.purchaseType === CART_TYPES.INVISIBLE && (
                                   <p>
                                        <strong>Product Invisible</strong>
                                   </p>
                              )}
                         </div>

                         {showAddToCart && (
                              <div className="add-to-cart">
                                   <CButton
                                        className="btn btn-blue-highlight btn-block"
                                        disabled={disableCartButton}
                                        onClick={() => {
                                             addToCart(CART_TYPES.ORGANIZATION);
                                        }}
                                   >
                                        ADD TO CART
                                   </CButton>
                              </div>
                         )}
                         {product?.purchaseType === CART_TYPES.INVISIBLE && (
                              <p>
                                   <strong>Product Invisible</strong>
                              </p>
                         )}
                    </div>
               )}
               <div className="training-product-footer">
                    <p>{contentFooter?.value}</p>
               </div>
          </div>
     );
};

export default TeamTrainingTab;
